var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content animate-panel", attrs: { id: "content" } },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "align-items": "center", gap: "20px" }
        },
        [_c("nav-tabs", { attrs: { tab: _vm.tab } })],
        1
      ),
      _vm._v(" "),
      _vm.isReady
        ? _c(
            "div",
            { staticClass: "hpanel" },
            [
              _c("tab-content", {
                attrs: { tab: _vm.tab, banners: _vm.banners }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ad75fb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ad75fb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/Products.vue
// module id = null
// module chunks = 